import cookies from 'cookies-js';
import IUserInfo from '@/app/common/model/IUserInfo';
import {Nullable} from '@/app/common/util/Nullable';
import ApiService from '@/app/common/service/ApiService';
import StorageRepository from '@/app/common/repository/StorageRepository';
import store from '@/app/store/store';

export default class LoginStrategy {
  public static async resolveLoginStrategy(userInfo: IUserInfo | string): Promise<Window | null | void> {
    let user;
    if (typeof userInfo === 'string') {
      user = JSON.parse(userInfo);
    } else {
      user = userInfo
    }
    if (user) {
      switch (user.type) {
        case 'C':
          return this.useUserLoginStrategy(user);
        default:
          return this.useAngularLoginStrategy(user)
      }
    }
  }

  private static async useUserLoginStrategy(userInfo: IUserInfo): Promise<Nullable<Window>> {
    ApiService.setHeader('Auth', `Bearer ${userInfo.token}`);
    ApiService.setHeader('License', `License ${userInfo.licenseKey}`);
    const response = await ApiService.get('/auth/permissions');
    StorageRepository.saveLicense(userInfo.licenseKey);
    StorageRepository.savePermissions(response.permissionList);
    await StorageRepository.saveUserInfo(userInfo);
    return window.open(`${location.origin}/users`, '_self')
  }

  private static async useAngularLoginStrategy(userInfo: IUserInfo): Promise<Nullable<Window>> {
    const currentLang = StorageRepository.getCurrentLang();
    ApiService.setHeader('Auth', `Bearer ${userInfo.token}`);
    ApiService.setHeader('License', `License ${userInfo.licenseKey}`);
    if (currentLang) {
      cookies.set('NG_TRANSLATE_LANG_KEY', currentLang.toLowerCase())
    }
    const response = await ApiService.get('/auth/permissions');
    StorageRepository.savePermissions(response.permissionList);
    await StorageRepository.saveUserInfo(userInfo);
    cookies.set('globalsClient', JSON.stringify({currentUser: userInfo, ...userInfo}));
    return window.open(`${location.origin}/old`, '_self')
  }
}
